import events from '../../actions/event-names';
import Config from '../../config';
import { showSuccess, showError } from '../../utils';

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    userList: [],
    isDetailsFetched: false,
    userDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //  USER LIST
    case `${events.GET_USER_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.userList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_USER_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            userList: [...state.userList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_USER_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //  USER DETAILS
    case `${events.GET_USER_DETAILS}_PENDING`: {
        return {
            ...state,
            userDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_USER_DETAILS}_FULFILLED`: {
        return {
            ...state,
            userDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_USER_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }

    //  ADD NEW USER
    case `${events.ADD_NEW_USER}_PENDING`: {
        return {
            ...state,
            isNewUserAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_USER}_FULFILLED`: {
        return {
            ...state,
            isNewUserAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_USER}_REJECTED`: {
        showError('User add failed')
        return {
            ...state,
            isNewUserAdded: 'REJECTED',
        };
    }

    default:
        return state;
    }
}
